import i18n from '../../helpers/i18n';

import InfoIcon from '../../icons/InfoIcon';

const AlreadyBlocked = ({ lang }) => {
  return (
    <div className='main-banner-container'>
      <div className='main-banner'>
        <div className='main-banner__title-container'>
          <InfoIcon />
          <div className='main-banner__title'>
            {i18n.get('blockUser.errorAlreadyBlockedTitle', lang)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlreadyBlocked;
